module.exports = __webpack_public_path__ + "img/CM-BS-25-Acura-Established.07804b6e.jpg";